import gql from 'graphql-tag'
import { session } from "./fragments.js";

export const sessionQuery = gql`
  query getUpdatedSession($id: ID!) {
    survey_session(id: $id) {
      ...Session
    } 
  }
  ${session}
`


// WEBPACK FOOTER //
// ./src/graphql/queries.js